'use client';

import { useEffect, useState } from 'react';

/**
 * Detects Amazon Silk browser and shows a lightweight compatibility notice.
 * Silk on Fire tablets older than ~2023 (Chromium < 111) may have minor
 * color rendering differences — the site remains fully functional.
 * Kindle e-readers are not supported (JavaScript-heavy app).
 */
export function SilkCompatBanner() {
  const [isSilk, setIsSilk] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const ua = navigator.userAgent;
    if (/Silk\//i.test(ua)) {
      setIsSilk(true);
    }
  }, []);

  if (!isSilk || dismissed) return null;

  return (
    <div
      role="alert"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        background: '#1e2d4a',
        color: '#e6eaf4',
        padding: '10px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '12px',
        fontSize: '13px',
        lineHeight: '1.4',
        borderTop: '1px solid #2c3858',
      }}
    >
      <span>
        <strong style={{ color: '#7aadff' }}>Kindle / Silk detected</strong>
        {' — '}
        This site works on Fire tablets. For the best experience use Chrome or Firefox on a
        desktop or laptop.
      </span>
      <button
        onClick={() => setDismissed(true)}
        aria-label="Dismiss"
        style={{
          flexShrink: 0,
          background: 'transparent',
          border: '1px solid #3a4e72',
          color: '#a0b0d0',
          borderRadius: '6px',
          padding: '4px 10px',
          cursor: 'pointer',
          fontSize: '12px',
        }}
      >
        OK
      </button>
    </div>
  );
}
